import { render, staticRenderFns } from "./verifyIdentity.vue?vue&type=template&id=0362b4aa&"
import script from "./verifyIdentity.vue?vue&type=script&lang=ts&"
export * from "./verifyIdentity.vue?vue&type=script&lang=ts&"
import style0 from "./verifyIdentity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports